import { Stack } from '@chakra-ui/react';
import { useRef } from 'react';

import { StyledScrollWrapper } from '$/components/common/StyledScrollWrapper';
import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { WhatsNewModal } from '$/components/core/WhatsNewModal';
import { useIsMobile } from '$/hooks/useIsMobile';
import { BackToTopButton } from '$/pages/DashboardPages/components/BackToTopButton';
import { ProjectModal } from '$/pages/DashboardPages/pages/Projects/components/ProjectModal';
import { CollectionSection } from '$/pages/DashboardPages/pages/Welcome/components/CollectionSection';
import { InspirationSection } from '$/pages/DashboardPages/pages/Welcome/components/InspirationSection';
import { ProjectFolderSection } from '$/pages/DashboardPages/pages/Welcome/components/ProjectFolderSection';
import { ProjectSection } from '$/pages/DashboardPages/pages/Welcome/components/ProjectSection';
import { WelcomeHeader } from '$/pages/DashboardPages/pages/Welcome/components/WelcomeHeader';

export const WelcomeDashboard = () => {
  const ref = useRef<HTMLDivElement>(null);
  const isMobile = useIsMobile();
  const { hasPermission } = useAuthorization();

  return (
    <Stack
      ref={ref}
      w='full'
      {...(!isMobile && {
        layerStyle: 'DashboardSection',
      })}
    >
      <StyledScrollWrapper>
        <Stack
          gap='6'
          overflowY='auto'
          w='full'
          {...(!isMobile && {
            p: '7',
          })}
        >
          <WelcomeHeader />
          {hasPermission('General_Project_Page') && <ProjectFolderSection />}
          <ProjectSection />
          <InspirationSection />
          <CollectionSection />
          <BackToTopButton containerRef={ref} right='65px' bottom='65px' />
        </Stack>
      </StyledScrollWrapper>
      <ProjectModal />
      <WhatsNewModal />
    </Stack>
  );
};
